module.exports = "../dist/frontend/icons/symbols/letters/a-white.svg?94b131de622ade6a26ba0b2f4c8a8c28";